"use client";

import { createI18nClient } from "next-international/client";

const locales = {
  en: () => import("./en.json"),
  cn: () => import("./cn.json"),
};

export const {
  useI18n,
  useScopedI18n,
  I18nProviderClient,
  useChangeLocale,
  I18nClientContext,
  useCurrentLocale
} = createI18nClient<typeof locales>(locales);
